import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { MpTitle } from 'shared/ui/MpTitle';
import { TextStyled } from '../ApplicationLanguagesM/ApplicationLanguagesM.styles';

interface ApplicationDeveloperMProps {
	developer: string;
	websiteUrl: string;
}

export const ApplicationDeveloperM: FC<ApplicationDeveloperMProps> = ({ developer, websiteUrl }) => {
	const { t } = useTranslation();

	return (
		<div style={{ marginBottom: `24px` }}>
			<MpTitle>{t(`Marketplace_Developer`)}</MpTitle>
			{websiteUrl === `` ? (
				<TextStyled>{developer}</TextStyled>
			) : (
				<TextStyled>
					<a rel='noreferrer' target='_blank' href={websiteUrl}>
						{developer}
					</a>
				</TextStyled>
			)}
		</div>
	);
};
